"use client";

import { authClient } from "@/lib/auth/client";

/**
 * Client-side hook for accessing session data
 * Uses better-auth's built-in React hook with React Query
 */
export function useSession() {
  return authClient.useSession();
}
